import { useEffect } from 'react';

const CLOSE_BY_LINK_CLICKED_EVENT_NAME = "closeByLinkClicked";
const dispatchLinkClickedEvent = (href) => {
  const event = new CustomEvent(CLOSE_BY_LINK_CLICKED_EVENT_NAME, {
    detail: {
      href
    }
  });
  document.dispatchEvent(event);
};
const useLinkClickedEvent = ({ callback }) => {
  useEffect(() => {
    document.addEventListener(CLOSE_BY_LINK_CLICKED_EVENT_NAME, callback);
    return () => {
      document.removeEventListener(CLOSE_BY_LINK_CLICKED_EVENT_NAME, callback);
    };
  }, [callback]);
};

export { dispatchLinkClickedEvent, useLinkClickedEvent };
//# sourceMappingURL=event.mjs.map
